// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export interface DynamicSearchWidthReducerState {
    searchWidth: number;
    loggedInExtraWidth: number;
}

const initialState: DynamicSearchWidthReducerState = {
    searchWidth: 0,
    loggedInExtraWidth: 0,
};
const extraSpacing = 60;
const actions = {
    "Pages/Header/SetSearchWidth": (
        draft: Draft<DynamicSearchWidthReducerState>,
        action: { primaryWidth: number; loggedInOffset: number },
    ) => {
        draft.searchWidth = action.primaryWidth - extraSpacing;
        draft.loggedInExtraWidth = action.loggedInOffset;
    },
};

const dynamicSearchWidthReducer = createTypedReducerWithImmer(initialState, actions);
export type DynamicSearchWidthActions = BunzlActionUnion<typeof actions>;
export default dynamicSearchWidthReducer;
